import React, { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ModalProvider } from 'react-simple-hook-modal'
import store from '@store/store'

import Header from '@organisms/Header'
import Footer from '@organisms/Footer'

import SiteRoutes from './SiteRoutes'
import datas from '@datas/rubriques.json'

const App = () => {
	return (
		<BrowserRouter basename={process.env.REACT_APP_BASENAME}>
			<Provider store={store}>
				<ModalProvider>
					<Header />
					<main id="main">
						<Suspense fallback={<div> </div>}>
							<SiteRoutes />
						</Suspense>
					</main>
					<Footer
						datas={datas && datas?.filter((i) => i?.footerMenu === true)}
					/>
				</ModalProvider>
			</Provider>
		</BrowserRouter>
	)
}
export default App
